import { render, staticRenderFns } from "./horizontalFeatureBlock.vue?vue&type=template&id=06671604&scoped=true"
import script from "./horizontalFeatureBlock.vue?vue&type=script&lang=js"
export * from "./horizontalFeatureBlock.vue?vue&type=script&lang=js"
import style0 from "./horizontalFeatureBlock.vue?vue&type=style&index=0&id=06671604&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06671604",
  null
  
)

export default component.exports